// Dummy data hook for leave type pie chart
export default function useLeaveTypePieData() {
  return [
    { type: 'Sick Leave', value: 10 },
    { type: 'Casual Leave', value: 8 },
    { type: 'Earned Leave', value: 6 },
    { type: 'Unpaid Leave', value: 2 },
  ];
}
